var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"pt-5 mx-auto",attrs:{"max-width":"70%"}},[_c('h1',{staticClass:"m-5"},[_vm._v("Worker Tools")]),_c('v-divider'),_c('ListUser')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }